import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customerSelect", "relevanceSelect", "contentCategorySelect"]
  static values = { url: String, prompt: String }

  connect() {
    this.selectedCategoryId = this.contentCategorySelectTarget.value
    this.fallbackOptions = Array.from(this.contentCategorySelectTarget.options, (option) => option.cloneNode(true))
    this.updateContentCategories()
  }

  disconnect() {
    this.abortController?.abort()
  }

  customerChanged() {
    this.selectedCategoryId = null
    this.updateContentCategories()
  }

  relevanceChanged() {
    this.selectedCategoryId = null
    this.updateContentCategories()
  }

  async updateContentCategories() {
    const customerId = this.customerSelectTarget.value
    const relevance = this.relevanceSelectTarget.value
    const customerSelected = customerId !== ""

    if (!customerSelected || relevance === "") {
      this.resetContentCategories()
      return
    }

    this.contentCategorySelectTarget.disabled = true
    this.abortController?.abort()
    this.abortController = new AbortController()

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("customer_id", customerId)
    url.searchParams.set("relevance", relevance)

    try {
      const response = await fetch(url, {
        headers: { Accept: "application/json" },
        signal: this.abortController.signal
      })

      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      this.populateContentCategories(await response.json())
    } catch (error) {
      if (error.name !== "AbortError") this.restoreFallbackCategories()
    }
  }

  resetContentCategories() {
    this.contentCategorySelectTarget.replaceChildren(this.promptOption())
    this.contentCategorySelectTarget.disabled = true
  }

  populateContentCategories(categories) {
    const options = [this.promptOption()]

    categories.forEach((category) => {
      const option = document.createElement("option")
      option.value = category.id
      option.textContent = category.name
      option.selected = this.selectedCategoryId?.toString() === category.id.toString()
      options.push(option)
    })

    this.contentCategorySelectTarget.replaceChildren(...options)
    this.contentCategorySelectTarget.disabled = false
    this.selectedCategoryId = null
  }

  restoreFallbackCategories() {
    const options = this.fallbackOptions.map((option) => option.cloneNode(true))
    this.contentCategorySelectTarget.replaceChildren(...options)
    this.contentCategorySelectTarget.disabled = false
  }

  promptOption() {
    const option = document.createElement("option")
    option.value = ""
    option.textContent = this.promptValue
    return option
  }
}
